<template>
    <div class="layout-wrapper layout-static">
        <Toast/>
        <AppMenu />

        <div class="content h-full">
            <router-view/>
        </div>

        <footer></footer>
    </div>
</template>

<script>
    import Toast from "primevue/toast";
    import AppMenu from "../../components/AppMenu";

    export default {
        name: "LayoutDashboard",
        components: {
            AppMenu, Toast,
        },
    };
</script>

<style lang="scss">
    @import "../../assets/theme/mytheme/variables";
    @import "../assets/scss/layout-dasboard";
    @import "../assets/scss/responsive";
</style>
